import { Injectable, Inject } from '@angular/core';
// import { Facebook } from '@ionic-native/facebook';
import { Platform } from '@ionic/angular';
// import { Contact } from '@awesome-cordova-plugins/contacts/ngx';
import {
  ContactModel,
  CONTACTS_SERVICE,
  IContactsService,
} from '@boxx/contacts-core';
import { Browser } from '@capacitor/browser';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';

@Injectable()
export class SharingService {
  private isIos = false;

  constructor(
    // private facebook: Facebook,
    @Inject(CONTACTS_SERVICE)
    private contactSrvc: IContactsService<any, ContactModel>,
    private plt: Platform,
    private socialShar: SocialSharing
  ) {
    this.plt.ready().then(() => {
      this.isIos = this.plt
        .platforms()
        .some((name) => ['ios', 'ipad', 'iphone'].includes(name));
    });
  }

  /*facebookSharing(data: FacebookModule.IPostData): Promise<any> {
        data.method = 'share';
        return this.facebook.showDialog(data)
    }*/

  async socialSharing(options: ISharingOptions) {
    try {
      try {
        this.socialShar.share(options.subject? options.message : 'Compartir', 'Compartir', options.message, '')
        .then(() => {}).catch((error) => {});

        // await Share.share({
        //   title: options.subject? options.message : 'Compartir',
        //   text: options.message,
        //   dialogTitle: 'Compartir',
        // });
      } catch (error) {}
    } catch (error) {}
    
    // return this.socialSharingSvc.shareWithOptions(options);
  }

  whatsappShare(options: IWhatsAppSharingOptions) {
    const message = options.message || null;
    const file = options.image || null;
    const url = options.url || null;
    return true;
    //return this.socialSharingSvc.shareViaWhatsApp(message, file, url);
  }

  whatsappShareToContact(receiver: string, options: IWhatsAppSharingOptions) {
    const message = options.message || null;
    const file = options.image || null;
    const url = options.url || null;
    return true;
    // return this.socialSharingSvc.shareViaWhatsAppToReceiver(
    //   receiver,
    //   message,
    //   file,
    //   url
    // );
  }

  whatsAppSendMessage(
    phoneNumber: string,
    countryCode: string,
    phoneCode: string,
    message: string
  ) {
    return new Promise((resolve, reject) => {
      let code: string;
      switch (countryCode) {
        case 'MEX':
          code = `${phoneCode}1`;
          break;
        case 'ARG':
          code = `${phoneCode}9`;
          break;
        default:
          code = phoneCode;
      }

      if (this.isIos) {
        const subs = this.contactSrvc.pickOne(phoneNumber).subscribe(
          (contact) => {
            if (!contact) {
              if (code.startsWith('+')) {
                code = code.substring(1);
              }

              this.openURL(
                `https://wa.me/${code}${phoneNumber}?text=${encodeURIComponent(
                  message
                )}`
              );
              resolve(contact);
              return subs.unsubscribe();
            }

            // this.socialSharingSvc.canShareVia('whatsapp', message).then(
            //   () => {
            //     this.whatsappShareToContact(contact.id, { message })
            //       .then(
            //         () => resolve(contact),
            //         (error) => {
            //           console.error('**** whatsappShareToContact', error);
            //           reject({ after: 'unknown', error: `Whatsapp: ${error}` });
            //         }
            //       )
            //       .finally(() => subs.unsubscribe());
            //   },
            //   (error) => {
            //     subs.unsubscribe();
            //     reject({ after: 'unknown', error: `Whatsapp: ${error}` });
            //   }
            // );
          },
          (error) => {
            console.error('**** whatsappShareToContact', error);
            reject({ after: 'unknown', error: `Whatsapp: ${error}` });
          }
        );
      } else {
        // this.whatsappShareToContact(`${code}${phoneNumber}`, { message }).then(
        //   () => resolve(phoneNumber),
        //   (error) => {
        //     console.error('**** whatsappShareToContact', error);
        //     reject({ after: 'unknown', error: `Whatsapp: ${error}` });
        //   }
        // );
      }
    });
  }

  makeCall(phoneNumber: string) {
    phoneNumber = encodeURIComponent(phoneNumber);
    window.location.href = 'tel:' + phoneNumber;
  }

  sendEmail(email: string) {
    window.location.href = 'mailto:' + email;
  }

  async openURL(url: string) {
    await Browser.open({ url: url, toolbarColor: 'primary', presentationStyle: 'fullscreen' });
  }

  async openExternalURL(url: string) {
    //this.iab.create(url, '_blank', 'location=yes, clearsessioncache=yes');
    //window.open(url, '_system');
    await Browser.open({ url });
  }
  
}

interface IWhatsAppSharingOptions {
  message: string;
  image?: string;
  url?: string;
}

interface ISharingOptions {
  message?: string;
  subject?: string;
  files?: string | string[];
  url?: string;
  chooserTitle?: string;
}
